import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { cn } from '@/lib/utils'
import { SignalField } from '@/components/motion/signal-field'

interface HeroFieldProps {
    accent?: string
    className?: string
}

// Background layer for page openings: the transaction field, faded at the
// edges, with a soft accent glow. Its section needs `isolate` so the layer
// sits behind the content.
export const HeroField: FC<HeroFieldProps> = ({ accent = '#8c5fff', className }): ReactNode => {
    return (
        <motion.div
            aria-hidden
            className={cn('pointer-events-none absolute inset-0 -z-10', className)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.6, delay: 0.2 }}
        >
            <div className='absolute inset-0 [mask-image:radial-gradient(ellipse_80%_75%_at_70%_40%,black_20%,transparent_100%)]'>
                <SignalField accent={accent} />
            </div>
            <div className='absolute -right-40 -top-32 size-[38rem] rounded-full opacity-20 blur-[140px]' style={{ backgroundColor: accent }} />
        </motion.div>
    )
}
